module.exports = {
   info: "Drag the uploaded file to this area or",
   info_button: "select on disk",
   upload_csv: "Upload metadata in CSV file format"
}
